"use client";

import Image from "next/image";

import BaseModel from "@/models/api/base/BaseModel";

import PricePod from "../PricePod";

interface OrderSummaryProps {
  model: BaseModel;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ model }) => {
  const {
    customerDetails,
    propositionId,
    propositions,
    isBecomingFiveStarMember,
  } = model;

  const imageSource = "/signup/sim.svg";

  const proposition = propositions.find(
    (proposition) => proposition.id === propositionId,
  );

  const aoMembership = propositions.find(
    (aoMembership) => aoMembership.subscription === "ao-membership",
  );

  if (!proposition || !aoMembership) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col border border-solid border-gray-50 rounded-lg">
        <div className="flex p-4">
          <div className="w-5 mr-4">
            <Image src={imageSource} alt="sim" width={100} height={100} />
          </div>

          <div className="w-full">
            <h2 className="mb-1">Ultimate 500GB</h2>

            <p className="text-body-sm mb-1">
              30-day SIM-only rolling plan
              <br />
              Unlimited UK minutes & texts
            </p>

            <span className="text-caption">Quantity: 1</span>

            <div className="mb-4">
              <PricePod
                hasMembership={customerDetails?.hasMembership ? true : false}
                memberPrice={proposition.memberFee}
                standardPrice={proposition.fee}
                memberDiscount={proposition.memberOnlyDiscount}
                isBecomingFiveStarMember={isBecomingFiveStarMember}
              />
            </div>

            <div className="flex justify-between mt-2">
              <span className="text-caption">Delivery</span>
              <span className="text-caption">Free</span>
            </div>
          </div>
        </div>

        {isBecomingFiveStarMember ? (
          <>
            <div className="flex flex-col border border-solid border-gray-50 border-l-0 border-r-0 border-b-0 px-4 pb-3 justify-between pt-4">
              <div className="flex">
                <div className="w-6 mr-4">
                  <span className="ico ico-five-star-membership"></span>
                </div>
                <div className="flex flex-col">
                  <p className="text-body-sm mb-2">
                    AO Membership including member-only discounts & deals, free
                    & unlimited delivery, and more.
                  </p>
                  <span className="font-bold font-headline text-water">
                    £{aoMembership?.fee}**
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col border border-solid border-gray-50 border-l-0 border-r-0 border-b-0 p-4">
              <div className="flex justify-between">
                <span className="text-title text-xl">Total</span>
                <div className="flex flex-col text-right">
                  <div className="text-heading-sm text-water">Pay today</div>
                  <div className="text-title text-2xl">
                    £{aoMembership?.fee}
                  </div>
                  <div className="text-heading-sm text-water mt-4">
                    Pay monthly
                  </div>
                  <div className="text-title text-2xl">
                    £{proposition.memberFee}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="flex border border-solid border-gray-50 border-l-0 border-r-0 border-b-0 px-4 pb-3 justify-between">
            <h2 className="text-xl pt-2">Total</h2>
            <div className="flex flex-col pt-2 text-right">
              <span className="text-heading-sm text-water">Pay monthly</span>
              <span className="text-title text-2xl">
                £
                {customerDetails?.hasMembership
                  ? proposition.memberFee
                  : proposition.fee}
              </span>
            </div>
          </div>
        )}
      </div>

      {isBecomingFiveStarMember && (
        <div className="bg-gray-10 text-caption px-4 py-3 border border-solid border-gray-50 rounded text-left mb-6 mt-6">
          ** Your AO Membership fee will be taken annually on the same date.
        </div>
      )}
    </>
  );
};

export default OrderSummary;
